/* QUIETUDE — le menu du site.

   Les trois headers portaient déjà leur bouton burger ; il ne leur manquait
   que ceci. Fichier séparé de quietude-drawer.js pour la même raison qui a
   sorti celui-ci de quietude.js : un fichier, un comportement. Le panier et
   le menu ne se connaissent que par les fonctions que chacun publie.

   Écoute déléguée sur le document, donc rien à rebrancher quand l'éditeur de
   thème re-rend une section — et les trois burgers sont pris par le même
   sélecteur, quel que soit le header rendu par la page.

   Markup dans snippets/qt-nav.liquid, styles dans quietude-nav.css. */
(function () {
  if (window.__qtNavBound) return;
  window.__qtNavBound = true;

  var OPENERS = '#nav-open,.burger,.mm-burger,.hy-burger,[data-nav-open]';
  var FOCUSABLE = 'a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])';
  var opener = null;

  function panel() { return document.querySelector('.qtnav'); }

  /* Sur desktop ce n'est pas la fenêtre qui défile mais .page-wrapper, à qui
     Horizon donne overflow:auto pendant que html et body restent en hidden ;
     sous 768px le rapport s'inverse. Les deux sont verrouillés, sans chercher
     lequel des deux est aux commandes à cette largeur. */
  function lockScroll(state) {
    document.documentElement.style.overflow = state ? 'hidden' : '';
    var wrap = document.querySelector('.page-wrapper');
    if (wrap) wrap.style.overflow = state ? 'hidden' : '';
  }

  function paint(state) {
    document.querySelectorAll('.qtnav').forEach(function (p) {
      p.classList.toggle('on', state);
      p.setAttribute('aria-hidden', String(!state));
    });
    document.querySelectorAll('.qtnav-scrim').forEach(function (s) {
      s.classList.toggle('on', state);
    });
    document.querySelectorAll(OPENERS).forEach(function (b) {
      b.setAttribute('aria-expanded', String(state));
    });
  }

  function open(state, trigger) {
    var p = panel();
    if (!p) return;

    if (state && typeof window.qtCloseCart === 'function') window.qtCloseCart();

    paint(state);
    lockScroll(state);

    if (state) {
      opener = trigger || null;
      var x = p.querySelector('.qtnav-x');
      if (x) x.focus();
    } else if (opener) {
      /* Le focus revient au bouton qui a ouvert le menu, sinon il repart du
         haut du document et la navigation au clavier recommence à zéro. */
      opener.focus();
      opener = null;
    }
  }

  /* Le menu s'efface quand le panier s'ouvre : deux panneaux ouverts en même
     temps se recouvriraient sans que rien ne dise lequel est actif. Le verrou
     de défilement est rendu au passage, et le panier repose aussitôt le sien.
     Il faut bien le rendre ici : le panier ne connaît que documentElement, si
     bien que le .page-wrapper laissé fermé par le menu ne serait plus jamais
     rouvert et bloquerait le défilement du desktop pour de bon. */
  function stepAside() {
    if (!document.querySelector('.qtnav.on')) return;
    paint(false);
    lockScroll(false);
    opener = null;
  }

  window.qtOpenNav = function () { open(true, null); };
  window.qtCloseNav = function () { open(false); };

  /* Le panier s'ouvre aussi sans clic sur son icône : quietude-pdp.js et
     quietude-rail.js appellent qtOpenCart après un ajout. On surveille le
     tiroir lui-même plutôt que d'envelopper cette fonction —
     quietude-fly-to-cart.js a posé un accesseur sur window.qtOpenCart dont le
     get rend son propre emballage et le set réécrit la cible interne : lire
     puis réassigner refermait la boucle sur elle-même, et le premier ajout au
     panier partait en récursion infinie. La classe du tiroir, elle, dit la
     même chose sans rien intercepter. */
  var cart = document.getElementById('drawer');
  if (cart && window.MutationObserver) {
    new MutationObserver(function () {
      if (cart.classList.contains('on')) stepAside();
    }).observe(cart, { attributes: true, attributeFilter: ['class'] });
  }

  document.addEventListener('click', function (e) {
    var hit = e.target.closest(OPENERS);
    if (hit) { e.preventDefault(); open(true, hit); return; }
    if (e.target.closest('[data-nav-close],.qtnav-scrim')) { e.preventDefault(); open(false); return; }
    /* Le tiroir n'ouvre qu'une fois /cart.js revenu ; fermer le menu dès le
       clic évite qu'il reste en place pendant l'aller-retour. */
    if (e.target.closest('.cart-btn,[data-cart-open]')) { stepAside(); }
  });

  document.addEventListener('keydown', function (e) {
    var p = document.querySelector('.qtnav.on');
    if (!p) return;
    if (e.key === 'Escape') { open(false); return; }
    if (e.key !== 'Tab') return;

    /* Tant que le menu couvre la page, la tabulation ne doit pas partir
       derrière lui : le contenu masqué reste focusable, et le focus y
       disparaîtrait sans rien laisser voir à l'écran. */
    var items = Array.prototype.filter.call(
      p.querySelectorAll(FOCUSABLE),
      function (el) { return el.offsetParent !== null; }
    );
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    else if (!p.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
  });
  /* ETHYLGO : les liens du menu visent des ancres de l'accueil. Sur l'accueil,
     le clic ne change pas de page : le menu doit se refermer de lui-même et
     rendre le défilement avant que le navigateur ne descende à l'ancre. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('.qtnav a[href*="#"]');
    if (a && a.pathname === location.pathname) open(false);
  });
})();
